import { Component , OnInit } from '@angular/core';
import * as $ from 'jquery';


@Component({
  selector: 'app-service',
  templateUrl: './service.component.html',
})
export class ServiceComponent implements OnInit {
  ngOnInit() {
  }
}
